<template>
  <section class="safety-effets">
    <div class="">
      <div class="">
        <div class="contents mx-auto side-effects-main-container">
          <b-container>
            <b-row class="justify-content-center">
              <b-col>
                <div class="">
                  
                  <p class="text-black mt-0">
                    JORNAY PM is a stimulant and a federally controlled substance (CII) used for the treatment of Attention Deficit Hyperactivity Disorder (ADHD) in people 6 years of age and older. <span class="no-wrap">JORNAY PM</span> is not recommended for use in children under 6 years of age with ADHD. 

                  </p>
                  <p class="text-black fw-extrabold">
                    JORNAY PM has a high risk of abuse, misuse, and addiction. Misuse and abuse of <span class="no-wrap">JORNAY PM</span>, other methylphenidate containing medicines, and amphetamine containing medicines, can lead to overdose and death. 
                  </p>

                  <p class="text-black">
                    Additional safety and side effect details:
                  </p>

                  <!-- <div class="mt-3"></div> -->
                  <!-- <p class='text-black'>
                    No JORNAY PM patients withdrew from clinical studies because of
                    insomnia or decreased appetite, and side effects did not
                    increase with dosing.
                  </p> -->
                </div>
              </b-col>
            </b-row>
            <b-row class="justify-content-start justify-content-md-start justify-content-xl-center list-container-safety-effects">
              <b-col md="11" class="p-xl-0" style="    max-width: 955px;
">
                <ul class="m-0 list-1 isi-list">
                  <li>
                    <p class="text-black">Other serious side effects include sudden death in people with heart disease, increased blood pressure and heart rate, and new or worsening mental (psychiatric) problems. 
                    </p>
                  </li>
                  <li>
                    <p class="text-black">
                      Seek help right away for chest pain, shortness of breath, fainting, or new or worsening mental symptoms. 

                    </p>
                  </li>
                  <li>
                    <p class="text-black">
                      Don’t take if allergic or taking monoamine oxidase inhibitors (MAOIs).
                    </p>
                  </li>
                  <li>
                    <p class="text-black">Other serious risks include painful erections, circulation problems, slowed growth (height and weight) in children, eye problems, and worsening Tourette’s.
                    </p>
                  </li>
                  <li>
                    <p class="text-black">The most common side effects are trouble sleeping, decreased appetite, restlessness, headache, nausea, mood swings, and vomiting. 
                    </p>
                  </li>
                </ul>
              </b-col>
  
            </b-row>
          </b-container>

          <!-- <div class="side-effects-container">
            <h3>May cause serious side effects, including:</h3>
            <b-container>
              <b-row class="justify-content-center">
                <b-col md="5" class="pr-0">
                  <ul class="isi-list pb-0">
                    <li>Abuse, misuse, and addiction</li>

                    <li>
                      Risks for people with serious heart disease
                    </li>
                  </ul>
                </b-col>

                <b-col md="5">
                  <ul class="isi-list pb-0 mb-0">
                    <li>Increased blood pressure and heart rate</li>

                    <li>Mental (psychiatric) problems</li>
                  </ul>
                </b-col>
              </b-row>
            </b-container>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div>
      <p class='fw-extrabold text-black text-center see see-data-title'>
        Scroll to see data
      </p>

      <div class='scroll-indicator'>
        <div
          class='scroll-indicator-thumb'
          :style='{
            width: thumbWidth + 'px',
            transform: 'translateX(' + thumbPos + 'px)',
          }'
        ></div>
      </div>
    </div>

    <div
      class='scrollable__wrapper mx-auto'
      ref='scrollContainer'
      @scroll='handleScroll'
    >
      <div class='scrollable callout mx-auto'>
        <div class='callout__contents'>
          <img src='@/assets/images/3_25/safety/data.webp' width='701' alt='' />
        </div>
      </div>
    </div> -->

    <div class="contents mx-auto pt-0 pb-0 pb-lg-0 bottom-note-content">
      <b-container>
        <b-row>
          <b-col>
            <p class="text-black  mt-0">
              These are not all possible side effects. Please see additional Important Safety Information, including Boxed Warning, below.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
export default {
  name: "SafetyEffects",
  data() {
    return {
      thumbPos: 0,
      thumbWidth: 0,
      scrollbarWidth: 175,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.updateThumb();
      window.addEventListener("resize", this.updateThumb);
    });
  },
  methods: {
    handleScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;
      const scrollableWidth = el.scrollWidth - el.clientWidth;
      const scrollRatio = el.scrollLeft / scrollableWidth;

      const trackWidth = this.scrollbarWidth - this.thumbWidth;
      this.thumbPos = scrollRatio * trackWidth;
    },
    updateThumb() {
      const el = this.$refs.scrollContainer;
      if (!el) return;
      const visibleRatio = el.clientWidth / el.scrollWidth;

      this.thumbWidth = Math.max(this.scrollbarWidth * visibleRatio, 20);

      this.handleScroll();
    },
  },
};
</script>
